/**
 * A set of mapped props for intrinsic element types.
 */
export const defaultMappedProps: Record<string, string> = {
  iframe: 'src',
  img: 'src',
  input: 'type',
};
